<h2 mat-dialog-title>Add Item</h2>
<mat-dialog-content style="margin-top: 50px;">
    <label>Item Name</label>
    <input [(ngModel)]="itemName" class="ml-[23px]" /> <!-- Two-way binding -->
</mat-dialog-content>

<label style="margin-left: 40px; margin-top: 50px;">Description</label>
<mat-dialog-content>
    <app-rich-textEditor (contentChange)="addMitigationStrategy($event)"
    [resetEditor]="resetRichTextEditor">
</app-rich-textEditor></mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close class="back-button">No</button>
  <button mat-button (click)="saveData()" class="save-next-button" style="color: white;">Save</button>
</mat-dialog-actions>
